import { render, staticRenderFns } from "./hbfx2.vue?vue&type=template&id=4236c906"
import script from "./hbfx2.vue?vue&type=script&lang=js"
export * from "./hbfx2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports